import gql from 'graphql-tag';
import { QueryItemFragment } from '../query/task.cartEndpoint';
import { ShopFragmentCartEndpoint } from './shops.cartEndpoint';

export const MostUsefulCommentFragment = gql`
  fragment MostUsefulCommentFragment on CatalogCommentsModel {
    # самый самый отзыв
    id
    date
    fio
    photos {
      id
      thumb
      big
    }
    peopleItem {
      fio
      date
      attachmentsItem {
        cacheItem {
          filePath
        }
      }
      id
      date
      averageReviewRating
      totalReviews
      favoriteRubric {
        id
        title
        affiliate_title
      }
    }
    rating
    text
    votes_no
    votes_yes
    _voted
  }
`;

const ProductBadgesFragment = gql`
  fragment ProductBadgesFragment on CatalogModel {
    badges {
      newbee {
        available
        link
      }
      hit {
        available
        link
      }
      discount {
        available
        link
      }
      promotion {
        available
        link
        title
      }
      superprice {
        available
        link
      }
      natural {
        available
        link
      }
    }
  }
`;

export const MultiPricesFragment = gql`
  fragment MultiPricesFragment on CatalogModel {
    multiPrices {
      id
      name
      buy_at_once
      price_retail
      price_current
      price_active
      weightPriceData {
        weight
        price
        price1Kg
        amount
      }
    }
  }
`;

const ProductCardGiftItemFragment = gql`
  fragment ProductCardGiftItemFragment on CatalogModel {
    promocodeGiftItems {
      type
      code
      gift_id
      catalog_id
      giftItem {
        id
        title
        fileItem {
          cacheItem {
            filePath
          }
        }
      }
    }
  }
`;

export const CatalogTasksItemsFragment = gql`
  fragment CatalogTasksItemsFragment on CatalogModel {
    taskItems {
      task {
        access {
          ...QueryItemFragment
        }
        complete {
          ...QueryItemFragment
        }
        progress {
          ...QueryItemFragment
        }
      }
    }
  }
  ${QueryItemFragment}
`;

const CatalogItemDefaultFieldsFragment = gql`
  fragment CatalogItemDefaultFieldsFragment on CatalogModel {
    id
    isMenu
    is_18plus
    is_not_for_sale
    measure_id
    expiration_title
    supply_title
    hit
    price_retail
    digital
    subtitle
    newbee
    sales_number
    title
    rating_comments
    comments_number
    active
    vesovoi
    war_id
    isExpressDeliveryAval
    isExpressPickupAval
    ...MultiPricesFragment
    ...ProductCardGiftItemFragment

    badgesList {
      id
      title
      identify
      color
    }
    is_our
    specialPriceData {
      amount
      weight
      price
      price1Kg
    }

    mainRootRubric {
      id
      title
      shortTitle
      short_title
      identify
      weight
    }

    mainBarRubric {
      id
      title
      shortTitle
      short_title
      identify
      weight
    }

    measureItem {
      weight
      symbol
    }

    isPromo
    oldPriceField
    discounPriceField
    currentPriceField
    symbolPriceField
    gds_count
    nearestDeliveryAmount
    oldPriceField2
    discounPriceField2
    currentPriceField2
    symbolPriceField2

    priceBlockWeightPrice

    isPostponed

    fileItem {
      cacheItem {
        filePath
      }
    }
    ...ProductBadgesFragment
    ...CatalogTasksItemsFragment
    weight_of_goods

    isFavorite
    available # { false: Подписаться }
    delivery {
      is_nearest # if true красная купить, else зеленая в корзину
      date
      date_with_timezone
    }

    specialPriceData {
      amount
      price
      weight
      price1Kg
    }
  }
  ${CatalogTasksItemsFragment}
  ${ProductBadgesFragment}
  ${ProductCardGiftItemFragment}
  ${MultiPricesFragment}
`;

export const CatalogItemCardFragment = gql`
  fragment CatalogItemCardFragment on CatalogModel {
    ...CatalogItemDefaultFieldsFragment
    variants {
      ...CatalogItemDefaultFieldsFragment
      size_range_id
      sizeRangeItem {
        id
        title
        sort
        type_name
        type_measure
      }
      group_id
      group_is_main
    }
  }
  ${CatalogItemDefaultFieldsFragment}
`;
export const CatalogItemListFragment = gql`
  fragment CatalogItemListFragment on CatalogModel {
    id
    isMenu
    is_not_for_sale
    title # именование товара
    price
    currentPriceField
    currentPriceField2
    symbolPriceField
    symbolPriceField2
    war_id
    digital
    catalogAnalogs {
      ...CatalogItemCardFragment
    }

    vesovoi

    priceBlockWeightPrice

    measureItem {
      symbol
      weight
    }
    mainRootRubric {
      id
      title
      shortTitle
      short_title
      identify
    }
    weight_of_goods
    fileItem {
      cacheItem {
        filePath # картинка  товара
      }
    }
    available # { false: Подписаться }
  }
  ${CatalogItemCardFragment}
`;
// export const CommentsItemsFragment = gql`
//   fragment CommentsItemsFragment on CommentsUnion {
//     commentsItems {
//       id
//       text
//       active
//       date
//       rating
//       fio
//       people_id
//       isCanEdit
//       isCanRateAnswer
//       answer
//       answer_date
//       type
//       #_voted
//       #votes_no
//       #votes_yes

//       catalogItem {
//         id
//         title
//         fileItem {
//           cacheItem {
//             filePath # картинка  товара
//           }
//         }
//       }

//       peopleItem {
//         fio
//         attachmentsItem {
//           cacheItem {
//             filePath
//           }
//         }
//       }

//       answerUserItem {
//         firstname
//         secondname
//         fio
//         attachmentsItem {
//           cacheItem {
//             filePath
//           }
//         }
//       }

//       photos {
//         id
//         thumb
//         big
//         isVideo
//         video {
//           title
//           file
//           width
//           height
//           converted
//         }
//       }
//     }
//   }
// `;

export const CommentsItemPeopleItemFragment = gql`
  fragment CommentsItemPeopleItemFragment on PeopleModel {
    fio
    attachmentsItem {
      cacheItem {
        filePath
      }
    }
    id
    date
    averageReviewRating
    totalReviews
    favoriteRubric {
      id
      title
      affiliate_title
    }
  }
`;

export const CommentsItemsFragment = gql`
  fragment CommentsItemsFragment on CatalogCommentsModel {
    id
    text
    active
    date
    rating
    fio
    people_id
    isCanEdit
    answer_user_id
    isCanRateAnswer
    answer
    answer_date
    type
    #_voted
    #votes_no
    #votes_yes
    answer_rating
    catalogItem {
      ...CatalogItemListFragment
    }
    peopleItem {
      ...CommentsItemPeopleItemFragment
    }
    answerUserItem {
      firstname
      secondname
      fio
      attachmentsItem {
        cacheItem {
          filePath
        }
      }
    }

    photos {
      id
      thumb
      big
      isVideo
      video {
        title
        file
        width
        height
        converted
      }
    }
  }
  ${CommentsItemPeopleItemFragment}
  ${CatalogItemListFragment}
`;

const OrderListItemProductRecipesFragment = gql`
  fragment OrderListItemProductRecipesFragment on RecipesModel {
    id
    title
    identifyIdURI
    attachmentsItem {
      cacheItem {
        filePath # путь карлито
      }
    }
  }
`;

export const ReviewsItemsFragment = gql`
  fragment ReviewsItemsFragment on ReviewsModel {
    id
    text
    date
    rating
    fio
    answer
    isCanRateAnswer
    isCanEdit
    answer_user_id
    answer_date
    answer_rating
    people_id
    tagList {
      id
      title
      sort
      active
    }
    peopleItem {
      attachmentsItem {
        cacheItem {
          filePath
        }
      }
    }
    answerUserItem {
      fio
      attachmentsItem {
        cacheItem {
          id
          filePath
        }
      }
    }
    photos {
      id
      thumb
      big
      isVideo
      video {
        title
        file
        width
        height
        converted
      }
    }
  }
`;

export const OrderItemFragment = gql`
  fragment OrderItemFragment on OrdersModel {
    secretKey
    type
    totalOrderItemsPrice
    availableForRefund
    table
    addressItem {
      comment
      title
      street
    }
    promocodeItem {
      type_id
      value
      is_mobile_only
      code
      title
    }
    ord_weight
    positionsAmount
    orderCommentsList {
      id
      type
      commentItems {
        option {
          title
        }
        comment {
          id
          type
          title
        }
        value
      }
    }
    addressCommentsList {
      id
      type
      commentItems {
        option {
          title
        }
        comment {
          id
          type
          title
        }
        value
      }
    }
    delivery_id
    need_receipt
    payment_id
    orderContainerPrice
    payment_title
    recipeUrl
    paid
    canOrderBeRejected
    #totalOrderItemsPrice
    paid_total
    canOrderBeChanged
    status_id
    bill_payed
    phone
    fio
    id # Заказ №...
    email
    digital
    date # от числа месяца
    price # на сумму
    bill_recieved # Кол-во бонусных баллов, начисленных после выполнения заказа
    delivery_cost

    fromPeopleFio
    fromPeoplePhone
    fromPeopleEmail
    digitalPromocodes

    statusItem {
      id
      title # Статус
      color
    }
    canOrderCommentsBeUpdated
    deliveryDate # Доставим заказ
    ordBeg # время доставки заказа "С"
    ordEnd # время доставки заказа "ДО"
    address_id # адрес доставки
    city_title # город
    street # улица
    flat # квартира
    delivery_store_id
    peopleItem {
      fio
      phone
    }
    deliveryStoreItem {
      id
      type
      name
      address
      paymentItems {
        id
        title
        maxPrice
        identify
        mainImage
      }
      shop {
        ...ShopFragmentCartEndpoint
      }
    }

    managerItem {
      us_name # ФИО менеджера
      phone
      fileItem {
        cacheItem {
          filePath # картинка менеджера
        }
      }
    }

    courierItem {
      cur_id
      cur_name # ФИО курьера
      cur_phone
      cur_car
      link
      fileItem {
        cacheItem {
          filePath # картинка менеджера
        }
      }
      medknItem {
        tempFullFilePath
      }
    }

    servicesItems {
      id
      totalPrice
      amount
      price
      serviceItem {
        id
        title
        svg_code
      }
    }

    ordersItems {
      id
      isAlreadyReviewed
      item_weight
      isFreeForTestDrive
      isCommented
      priceDiff
      weightDiff
      averWeight
      averPrice
      amount
      price
      availableForRefund
      weight
      weight_total
      getTotalOrderItemPrice # цена за товар
      getOrderItemWeightPrice
      buyButton # кнопка статуса товара ("цена"/"Товар закончился на складе/"Подписаться на товар")
      catalogItem {
        ...CatalogItemListFragment
        getProductRecipesById @include(if: $includeRecipes) {
          recipeItems {
            ...OrderListItemProductRecipesFragment
          }
        }
      }
      replacementItems {
        id
        amount
        price
        total
        catalogItem {
          id
          title
          fileItem {
            cacheItem {
              filePath
            }
          }
        }
      }
      replacementItems {
        id
        amount
        price
        total
        catalogItem {
          id
          title
          fileItem {
            cacheItem {
              filePath
            }
          }
        }
      }

      refundItem {
        id
        order_id
        order_item_id
        amount
        total
        comment
        refund_type_id
        total_weight
        type {
          id
          title
          comment
        }
        date
        photos {
          id
          thumb
          big
          isVideo
          video {
            title
            file
            width
            height
            converted
          }
        }
        commentItems {
          id
          text
          weight
          active
        }
      }
    }
  }
  ${CatalogItemListFragment}
  ${OrderListItemProductRecipesFragment}
  ${ShopFragmentCartEndpoint}
`;

export const PromocodeGiftItemsFragment = gql`
  fragment PromocodeGiftItemsFragment on CatalogModel {
    promocodeGiftItems {
      type
      code
      gift_id
      catalog_id
      giftItem {
        id
        title
        fileItem {
          cacheItem {
            filePath
          }
        }
      }
    }
  }
`;
